/**
 * 로그인·이메일 인증 등에 쓰는 이메일 정규화·형식 검사
 * (RFC 5322 전체 준수 아님, 일반 웹 서비스 수준)
 */

export function normalizeEmailForAuth(raw: string): string {
	return raw.trim().toLowerCase();
}

/**
 * @returns 정규화된 문자열이 유효한 이메일 형식이면 true
 */
export function isValidEmailFormat(raw: string): boolean {
	const email = normalizeEmailForAuth(raw);
	if (!email || email.length > 254) return false;

	const at = email.indexOf('@');
	if (at <= 0 || at !== email.lastIndexOf('@')) return false;

	const local = email.slice(0, at);
	const domain = email.slice(at + 1);
	if (!local || !domain || local.length > 64) return false;
	if (domain.startsWith('.') || domain.endsWith('.') || domain.includes('..')) return false;
	if (local.startsWith('.') || local.endsWith('.') || local.includes('..')) return false;

	// 로컬: 일반적인 ASCII 이메일 허용 문자
	const localOk = /^[a-z0-9](?:[a-z0-9._%+-]*[a-z0-9])?$/i.test(local);
	// 도메인: 라벨 + 최상위 도메인 2자 이상
	const domainOk =
		/^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]*[a-z0-9])?)+$/i.test(domain) &&
		/\.[a-z]{2,}$/i.test(domain);

	return localOk && domainOk;
}
